import rems from './utils/rems';

const fontFamilies = {
  fontFamilyPrimary: '"Source Sans Pro", "Helvetica Neue", Helvetica, Arial',
  fontFamilyMonospace: '"Courier New", Courier, monospace',
};

const fontWeights = {
  fontWeightBase: 400,
  fontWeightHeavy: 700,
  fontWeightHeavier: 900,
};

const fontSizes = {
  fontSizeBase: rems(20),
  fontSizeXxl: rems(24),
  fontSizeXl: rems(22),
  fontSizeLg: rems(20),
  fontSizeMd: rems(18),
  fontSizeSm: rems(16),
  fontSizeXs: rems(14),
  fontSizeXxs: rems(12),
  fontSizeHero: rems(54),
  fontSizeH1: rems(48),
  fontSizeH2: rems(40),
  fontSizeH3: rems(30),
  fontSizeH4: rems(24),
  fontSizeH5: rems(20),
  fontSizeH6: rems(16),
};

export default {
  ...fontFamilies,
  ...fontWeights,
  ...fontSizes,
};
